module.exports = __webpack_public_path__ + "static/index/assets/img/icon_3.1336a5d2.png";